import { createReducer, on } from '@ngrx/store';
import * as loggerActions from '../actions/logger.actions';

export interface State {
  exception: any;
  information: any;
}

const initialState: State = {
  exception: null,
  information: null
};

export const reducer = createReducer(
  initialState,
  on(loggerActions.Exception, (state, action) => ({
    ...state,
    exception: action.error,
  })),
  on(loggerActions.Information, (state, action) => ({
    ...state,
    information: action.information,
  })),
);
